"use strict";
import {appConfig} from "../config/app.conf";

export const rutasService = {
    all
}


async function all(lang) {
    var requestOptions = {
        method: 'GET',
        redirect: 'follow'
    };

    const rawResponse = await fetch(`https://api.${appConfig.api}/geometries/routes/${lang}`,
        requestOptions);
    const content = await rawResponse.json()
    const data = await content

    return data
}